export default {
    path: '/admin',
    component: () => import('../views/Global/GenericDashboardView.vue'),
    meta: {
        private: true,
        accountTypes: ['support'],
    },
    children: [
        {
            path: 'accounts',
            name: 'admin-accounts',
            component: () => import('@/components/Admin/AdminSettings/components/AdminAccounts/AdminAccounts.vue'),
        },
        {
            path: 'contract-templates',
            name: 'admin-contract-templates',
            component: () => import('@/components/Admin/AdminSettings/components/ContractTemplates/ContractTemplates.vue'),
        },
        {
            path: 'countries',
            name: 'admin-countries',
            component: () => import('@/components/Admin/AdminSettings/components/AdminCountries/AdminCountries.vue'),
        },
        {
            path: 'document-tags',
            name: 'admin-document-tags',
            component: () => import('@/components/Admin/AdminSettings/components/AdminDocumentTags/AdminDocumentTags.vue'),
        },
        {
            path: 'emails',
            name: 'admin-emails',
            component: () => import('@/components/Admin/AdminSettings/components/AdminEmails/AdminEmails.vue'),
        },
        {
            path: 'legal-task-types',
            name: 'admin-legal-task-types',
            component: () => import('@/components/Admin/AdminSettings/components/LegalTaskTypes/LegalTaskTypes.vue'),
        },
        {
            path: 'feedback',
            name: 'admin-feedback',
            component: () => import('@/components/Admin/AdminSettings/components/AdminFeedback/AdminFeedback.vue'),
        },
        {
            // TEMPORARY — Ligo migration cleanup, see AdminInvoices.vue
            path: 'invoices',
            name: 'admin-invoices',
            component: () => import('@/components/Admin/AdminSettings/components/AdminInvoices/AdminInvoices.vue'),
        },
        {
            path: 'jobs',
            name: 'admin-jobs',
            component: () => import('@/components/Admin/AdminSettings/components/AdminJobs/AdminJobs.vue'),
        },
        {
            path: 'job-categories',
            name: 'admin-job-categories',
            component: () => import('@/components/Admin/AdminSettings/components/AdminJobCategories/AdminJobCategories.vue'),
        },
        {
            path: 'licenses',
            name: 'admin-licenses',
            component: () => import('@/components/Admin/AdminSettings/components/Licenses/Licenses.vue'),
        },
        {
            path: 'license-types',
            name: 'admin-license-types',
            component: () => import('@/components/Admin/AdminSettings/components/LicenseTypes/LicenseTypes.vue'),
        },
        {
            path: 'packages',
            name: 'admin-packages',
            component: () => import('@/components/Admin/AdminSettings/components/AdminPackages/AdminPackages.vue'),
        },
        {
            path: 'payment-methods',
            name: 'admin-payment-methods',
            component: () => import('@/features/admin/payment-methods'),
        },
        {
            path: 'products',
            name: 'admin-products',
            component: () => import('@/components/Admin/AdminSettings/components/AdminProducts/AdminProducts.vue'),
        },
        {
            path: 'regions',
            name: 'admin-regions',
            component: () => import('@/components/Admin/AdminSettings/components/AdminRegion/AdminRegion.vue'),
        },
        {
            path: 'notaries',
            name: 'admin-notaries',
            component: () => import('@/features/admin/notaries'),
        },
        {
            path: 'risk-words',
            name: 'admin-risk-words',
            component: () => import('@/components/Admin/AdminSettings/components/AdminRiskWords/AdminRiskWords.vue'),
        },
        {
            path: 'sectors',
            name: 'admin-sectors',
            component: () => import('@/components/Admin/AdminSettings/components/AdminSectors/AdminSectors.vue'),
        },
        {
            path: 'service-providers',
            name: 'admin-service-providers',
            component: () => import('@/components/Admin/AdminSettings/components/AdminServiceProviders/AdminServiceProviders.vue'),
        },
        {
            path: 'users',
            name: 'admin-users',
            component: () => import('@/components/Admin/AdminSettings/components/AdminUsers/AdminUsers.vue'),
        },
        {
            path: 'verbal-consents',
            name: 'admin-verbal-consents',
            component: () => import('@/components/Admin/AdminSettings/components/AdminVerbalConsents/AdminVerbalConsents.vue'),
        },
        {
            path: 'tenants',
            component: () => import('@/components/Admin/AdminSettings/components/Tenants/TenantsRoot.vue'),
            meta: {
                sessionRoles: ['admin'],
            },
            children: [
                {
                    path: '',
                    name: 'admin-tenants',
                    component: () => import('@/components/Admin/AdminSettings/components/Tenants/TenantsList.vue'),
                },
                {
                    path: ':id',
                    children: [
                        {
                            path: '',
                            name: 'admin-tenant-details',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/TenantDetails.vue'),
                        },
                        {
                            path: 'name',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/NameForm.vue'),
                        },
                        {
                            path: 'email-template-type',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/EmailTemplateType.vue'),
                        },
                        {
                            path: 'invoice-provider',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/InvoiceProvider.vue'),
                        },
                        {
                            path: 'layout-template',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/LayoutTemplateForm.vue'),
                        },
                        {
                            path: 'contacts',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/ContactsForm.vue'),
                        },
                        {
                            path: 'sender',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/SenderDetailsForm.vue'),
                        },
                        {
                            path: 'app',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/AppDetails.vue'),
                        },
                        {
                            path: 'fav-icon',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/FavIconForm.vue'),
                        },
                        {
                            path: 'logo-details',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/LogoDetails.vue'),
                        },
                        {
                            path: 'colors',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/ColorsForm.vue'),
                        },
                        {
                            path: 'terms-and-conditions',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/TermsAndConditionsForm.vue'),
                        },
                        {
                            path: 'privacy-policy',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/PrivacyPolicyForm.vue'),
                        },
                        {
                            path: 'wwft-information',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/WWFTInformationForm.vue'),
                        },
                        {
                            path: 'chatbase',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/ChatBaseForm.vue'),
                        },
                        {
                            path: 'mollie-settings',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/MollieSettings.vue'),
                        },
                        {
                            path: 'moneybird-settings',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/MoneybirdSettings.vue'),
                        },
                        {
                            path: 'airbill-settings',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/AirbillSettings.vue'),
                        },
                        {
                            path: 'brevo-settings',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/BrevoSettings.vue'),
                        },
                        {
                            path: 'support-desk-settings',
                            name: 'admin-tenant-support-desk-settings',
                            component: () => import('@/features/admin/support-desk-settings'),
                        },
                        {
                            path: 'api-keys',
                            name: 'admin-tenant-api-keys',
                            component: () => import('@/features/admin/own-label-api-keys'),
                        },
                        {
                            path: 'signrequest-settings',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/SignrequestSettings.vue'),
                        },
                        {
                            path: 'funnel-links/:field',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/FunnelLinks/FunnelLinkField.vue'),
                        },
                        {
                            path: 'email-data/:field',
                            component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/EmailData/EmailDataField.vue'),
                        },
                        {
                            path: 'oauth',
                            children: [
                                {
                                    path: 'google',
                                    component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/oauth/GoogleOAuthForm.vue'),
                                },
                                {
                                    path: 'facebook',
                                    component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/oauth/FacebookOAuthForm.vue'),
                                },
                                {
                                    path: 'linkedin',
                                    component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/oauth/LinkedInOAuthForm.vue'),
                                },
                                {
                                    path: 'apple',
                                    component: () => import('@/components/Admin/AdminSettings/components/Tenants/Details/oauth/AppleOAuthForm.vue'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },

        {
            path: ':(.*)',
            redirect: { name: 'admin-accounts' },
        },
    ],
};
